import { Container, Row, Col, Media, Button,Modal } from 'react-bootstrap'
import ModalTvc from "../tvc/ModalTvc"
import { useState } from 'react'

function LearnHowTo (props) {

const [lgShow, setLgShow] = useState(false);

return (
<div>
	<div className="tvc__howTo">
		<Container>
			<div className="">
				<h2 className="tvc__title mb-4"><strong>The Vitamin Checklist</strong></h2>
				<h1 className="tvc__howTo--desc text-uppercase text-orange">Learn how to choose a high <br className="br-none-991"/>quality food supplement</h1>
				<h2>Don't buy another vitamin until you read this!</h2>
			</div>
			<div className="mb-5 mt-5 text-btn-center">
				<Button variant="link" onClick={() => setLgShow(true)}>
				<a className="tvc__howTo--btn text-uppercase px-3 py-2 text-decoration-none text-white">Get the Checklist</a></Button>
			</div>
			<Modal
				size="lg"
				show={lgShow}
				onHide={() =>
				setLgShow(false)}
				aria-labelledby="example-modal-sizes-title-lg"
				>
				<ModalTvc global={props.global}/>
			</Modal>
			<Row>
				<Col lg={6} md={12} sm={12}>
				<Media>
					<img className="mr-3 img-fluid" src="../images/tvc/img-testimonial-louise-willett01.png" alt="Louise W" />
					<Media.Body>
						<p className="tvc__howTo--testemony"><em>&quot;Very well put together with lots of color and great information to get the message across&quot;</em>
							<br />
							<em><strong>- Louise W.</strong></em>
						</p>
					</Media.Body>
				</Media>
				</Col>
				<Col lg={6} md={12} sm={12}>
				<img className="mr-3 img-fluid tvc__threeSpoon" src="../images/tvc/img-hero-inset-three-spoon01.png" alt="Spoons" /></Col>
			</Row>
		</Container>
	</div>
	<style jsx global>{`
		.btn-link .tvc__howTo--btn{
            font-size: 2rem;
            background: #4575B5;
            border-radius: 5px;
		}
		.btn-link .tvc__howTo--btn:hover,
		.btn-link .tvc__howTo--btn:active,
		.btn-link .tvc__howTo--btn:focus{
		    background: #5582be;
		}
		@media(max-width: 480px){
		.btn .tvc__howTo--btn{
            font-size: 1.2rem!important;
            }
		}
		`}
	</style>
	<style jsx>{`
		.tvc__howTo{
            padding: 80px 15px 0px;
            background: #efefef url(../images/tvc/img-bg-hero01.jpg);
		}
		.tvc__title{
		    font-size: 2rem;
		}
		.tvc__howTo--desc{
            font-family: 'Oswald', sans-serif;
            font-size:4rem;
		}
		p.tvc__howTo--testemony{
		    font-size: 1.2rem;
		}
		.tvc__threeSpoon{
		    margin-top: -120px;  
		}
            @media(max-width: 991px){
                .br-none-991{
                    display: none;
                }
                .tvc__threeSpoon {
                    margin-top: 10px;
                }
                .text-btn-center{
                    text-align:center!important;
                }
            }
            @media(max-width: 480px){
                .tvc__howTo--desc{
                    font-size:2rem;
                }
				.tvc__title{
					font-size: 1.5rem;
				}
                h2{
                    font-size:1.5rem;
                }
            }
		`}
	</style>
</div>
);
}
export default LearnHowTo;